import gql from 'graphql-tag'

export const CREATE_EVENT = gql`
  mutation createEvent($event: CreateEventData!, $organizationSlug: String!) {
    createEvent(event: $event, organizationSlug: $organizationSlug) {
      id
      title
    }
  }
`

export const UPDATE_EVENT = gql`
  mutation updateEvent($id: ID!, $event: UpdateEventData!, $location: LocationInput!, $publishChanges: Boolean) {
    updateEvent(eventId: $id, event: $event, location: $location, publishChanges: $publishChanges)
  }
`

export const GET_EVENTS = gql`
  query getEvents($organizationSlug: String!) {
    getEvents(organizationSlug: $organizationSlug) {
      id
      title
      to
      from
      eventTemplate {
        id
        title
      }
      orderItems {
        id
        name
        eventId
      }
    }
  }
`

export const UPDATE_EVENT_WITH_EVENT_TEMPLATE_ID = gql`
  mutation UpdateEventWIthEventTemplateId(
    $organizationSlug: String!
    $eventTemplateId: ID!
    $eventInput: [PerformanceInput!]!
  ) {
    updateEventWithEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
      eventInput: $eventInput
    )
  }
`
export const CHANGE_EVENT_VENUE = gql`
  mutation changeEventVenue($eventId: ID!, $venueId: ID!) {
    changeEventVenue(eventId: $eventId, venueId: $venueId)
  }
`

export const PUBLISH_EVENT = gql`
  mutation publishEvent($id: ID, $eventTemplateId: ID) {
    publishEvent(eventId: $id, eventTemplateId: $eventTemplateId)
  }
`

export const EVENT_SOLD_OUT = gql`
  mutation eventSoldOut($id: ID!, $organizationSlug: String!) {
    eventSoldOut(eventId: $id, organizationSlug: $organizationSlug)
  }
`

export const EVENT_AVAILABLE = gql`
  mutation eventAvailable($id: ID!, $organizationSlug: String!) {
    eventAvailable(eventId: $id, organizationSlug: $organizationSlug)
  }
`

export const EVENT_CANCELED = gql`
  mutation eventCanceled($id: ID!, $organizationSlug: String!) {
    eventCanceled(eventId: $id, organizationSlug: $organizationSlug)
  }
`

export const UPDATE_CANCELLATION_NOTIFICATION = gql`
  mutation updateCancellationNotification(
    $id: ID!
    $organizationSlug: String!
    $notification: String!
  ) {
    updateCancellationNotification(
      eventId: $id
      organizationSlug: $organizationSlug
      cancellationNotification: $notification
    )
  }
`

export const GET_EVENTS_AND_QUOTA = gql`
  query getEventsAndQuota($organizationSlug: String!, $filter: String) {
    getEvents(organizationSlug: $organizationSlug, filter: $filter) {
      id
      title
      to
      from
      cover
      extraModules {
        ticketing
      }
      eventTemplate {
        id
        title
        durationInMins
      }
      totalNumberOfTickets
      totalEarnings
      totalTicketsSold
      location {
        city
      }
    }
    getOrganization(organizationSlug: $organizationSlug) {
      type
    }
    me {
      eventQuota
    }
  }
`

export const GET_EVENTS_REPORTS = gql`
  query getEventsReport(
    $organizationSlug: String!
    $searchTerm: String
    $from: String
    $to: String
  ) {
    getEventsReport(
      organizationSlug: $organizationSlug
      searchTerm: $searchTerm
      from: $from
      to: $to
    )
  }
`

export const GET_WORKING_EVENTS = gql`
  query getWorkingEvents {
    getWorkingEvents {
      id
      title
      to
      from
      cover
      extraModules {
        ticketing
      }
      organization {
        slug
        type
      }
      totalNumberOfTickets
      totalEarnings
      totalTicketsSold
      location {
        city
      }
    }
  }
`

export const GET_EVENT_FLOOR_PLAN = gql`
  query getEventFloorPlan($eventId: ID!) {
    getEventFloorPlan(eventId: $eventId) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      venueId
      venueAvailability {
        eventId
        availability
      }
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        initialQuantity
        from
        to
        itemMeta
        sectionSeats
        color
      }
    }
    getVenues {
      id
      imageUrl
      seats
      predefinedSections
      name
    }
  }
`
export const GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS = gql`
  query getEventFloorPlanAndOrderItems(
    $eventId: ID!
    $includeOrderItemsWithTicketSellerTrue: Boolean
  ) {
    getEventFloorPlanAndOrderItems(
      eventId: $eventId
      includeOrderItemsWithTicketSellerTrue: $includeOrderItemsWithTicketSellerTrue
    ) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      venueId
      canceled
      venue {
        name
        seats
        predefinedSections
        imageUrl
      }
      venueAvailability {
        eventId
        availability
      }
      orderItems {
        id
        name
        type
        price
        currency
        currentlyAvailable
        createdAt
        membership
        prepaidCoupon
        updatedAt
        description
        deletedAt
        quantity
        initialQuantity
        orderItemTemplateId
        from
        to
        sectionSeats
        itemMeta
        color
      }
      metadata
    }
  }
`

export const GET_EVENT_SETTINGS = gql`
  query getEventSettings($id: ID!) {
    getEvent(id: $id) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      createdAt
      status
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
      }
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      interests {
        id
        name
      }
    }
  }
`

export const GET_EVENT_PREVIEW_DATA = gql`
  query getEventPreviewData($eventId: ID!) {
    getEventPreviewData(eventId: $eventId) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      status
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      organization {
        publicName
        logo
        description
        webLink
        email
        facebookLink
        instagramLink
      }
      orderItems {
        id
        price
      }
    }
  }
`

export const GET_EVENT_SETTINGS_AND_LOGGED_USER = gql`
  query getEventSettings($id: ID!) {
    getEvent(id: $id) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      createdAt
      status
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
      }
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      interests {
        id
        name
      }
    }
    me {
      flags
    }
  }
`

export const GET_EVENT_ADS = gql`
  query getEventAds($eventId: ID!) {
    getEventAds(eventId: $eventId) {
      url
      title
      imageUrl
      logoUrl
    }
  }
`

export const GET_EVENT_AND_LOGGED_USER = gql`
  query getEventAndUser($id: ID!) {
    getEvent(id: $id) {
      id
      title
      eventCode
      from
      to
      venueId
      soldOut
      applicationsOpen
      canceled
      cancellationNotification
      status
      hasPurchasableTickets
      cover
      scheduledPublishDate
      eventCategory {
        name
      }
      extraModules {
        id
        workshops
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        scanEntries
        ticketing
        floorPlan
      }
      location {
        venue
      }
      slug
    }
    me {
      id
      firstName
      lastName
      type
      flags
      isVerifiedByCoreEvent
    }
    getPendingRequestsCount(eventId: $id)
    getEventOrganizationType(eventId: $id)
  }
`

export const GET_EVENT_CATEGORIES = gql`
  query getEventCategories($id: ID!) {
    getEventCategories(id: $id) {
      id
      slug
      attendeeFields
      flags
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
      }
      categories {
        id
        name
        color
        zones
        default
      }
      id
      numberOfZones
      title
      to
      from
      flags
      builder {
        id
      }
      applicationsOpen
    }
  }
`

export const GET_EVENT_USERS_AND_INVITES = gql`
  query getEventUsersAndInvites($organizationSlug: String!, $eventId: Int!) {
    getEventUsers(organizationSlug: $organizationSlug, eventId: $eventId) {
      id
      firstName
      lastName
      email
      eventRole
    }
    getEventInvites(organizationSlug: $organizationSlug, eventId: $eventId) {
      id
      email
      eventRole
      expired
    }
  }
`

export const GET_EVENT_AND_ORDER_ITEMS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsAndOrderItemsByEventTemplateId($organizationSlug: String!, $eventTemplateId: ID!) {
    getEventsAndOrderItemsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      from
      promoCodes {
        id
        name
        code
        createdAt
        updatedAt
        from
        to
      }
      orderItems {
        id
        eventId
        name
        type
        price
        currency
        description
        membership
        createdAt
        updatedAt
        quantity
        initialQuantity
        currentlyAvailable
        from
        to
        ticketSellerOrganizations {
          id
          name
        }
      }
    }
  }
`

export const GET_EVENTS_ORDERS_AND_ORDER_ITEMS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsOrdersAndOrderItemsByEventTemplateId(
    $eventTemplateId: ID!
    $pagination: Pagination!
    $searchTerm: String
    $eventId: ID
  ) {
    getEventsOrdersAndOrderItemsByEventTemplateId(
      eventTemplateId: $eventTemplateId
      pagination: $pagination
      searchTerm: $searchTerm
      eventId: $eventId
    )
  }
`

export const GET_EVENTS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsByEventTemplateId($organizationSlug: String!, $eventTemplateId: ID!) {
    getEventsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      performanceType
      title
      from
      to
      eventCode
      slug
      venueId
      audienceCapacity
      applicationsOpen
      location {
        id
        venue
      }
      orderItems {
        orderItemTemplateId
        id
        name
        quantity
        initialQuantity
      }
    }
  }
`

export const GET_EVENTS_WITH_TICKET_SELLER_ORGANIZATIONS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsWithTicketSellerOrganizationsByEventTemplateId(
    $organizationSlug: String!
    $eventTemplateId: ID!
  ) {
    getEventsWithTicketSellerOrganizationsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      performanceType
      title
      from
      to
      eventCode
      slug
      venueId
      audienceCapacity
      applicationsOpen
      location {
        id
        venue
      }
      orderItems {
        orderItemTemplateId
        id
        name
        quantity
        initialQuantity
        ticketSellerOrganizations {
          id
          name
        }
      }
    }
  }
`

export const GET_PRINT_DATA = gql`
  query GetPrintData($id: ID!, $attendeeId: ID!) {
    getEvent(id: $id) {
      title
      numberOfZones
      builder {
        id
        items
        backgroundImage
        orientation
        format
      }
      attendeeFields
    }
    getAttendee(attendeeId: $attendeeId) {
      id
      category {
        name
        color
        zones
      }
      fields
      avatar
      zones
      barcode
      qrcode
      printCount
    }
  }
`

export const GET_BULK_PRINT_DATA = gql`
  query GetBulkPrintData($eventId: ID!, $attendeeIds: [ID]) {
    getEvent(id: $eventId) {
      title
      numberOfZones
      builder {
        items
        backgroundImage
        orientation
        format
      }
      attendeeFields
    }
    getAccreditations(attendeeIds: $attendeeIds, eventId: $eventId) {
      id
      barcode
      qrcode
      category {
        name
        color
        zones
      }
      fields
      avatar
      zones
      printCount
    }
  }
`

export const SEARCH_EVENT_ACCREDITATIONS = gql`
  query searchEventAccreditations($eventId: ID!, $status: String!, $input: String!) {
    searchEventAccreditations(eventId: $eventId, status: $status, input: $input)
  }
`

export const GET_EVENT_ACCREDITATIONS_ONLY = gql`
  query getEventAccreditationsOnly(
    $status: String
    $filters: JSON
    $eventId: ID!
    $quickSearch: String
    $visibleFields: [String!]
    $pagination: Pagination
  ) {
    getEventAccreditations(
      eventId: $eventId
      status: $status
      quickSearch: $quickSearch
      visibleFields: $visibleFields
      filters: $filters
      pagination: $pagination
    )
  }
`

export const CHECK_IF_ATTENDEE_ALREADY_EXISTS = gql`
  query checkIfAttendeeAlreadyExistsOnEvent($eventId: ID!, $attendee: AttendeePersonalInput!) {
    checkIfAttendeeAlreadyExistsOnEvent(eventId: $eventId, attendee: $attendee)
  }
`

export const GET_EVENT_DETAILS = gql`
  query getEventAccreditations($eventId: ID!) {
    getEvent(id: $eventId) {
      id
      managed
      attendeeFields
      currency
      slug
      quickPrint
      venueId
      audienceCapacity
      builder {
        id
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
        floorPlan
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        color
        name
        zones
      }
      organization {
        type
      }
    }
    getAccreditationCount(eventId: $eventId)
  }
`

export const GET_EVENT_DETAILS_WITH_FILTERED_ATTENDEE_FIELDS = gql`
  query getEventAccreditations($eventId: ID!) {
    getEventWithFilteredAttendeeFields(id: $eventId) {
      id
      managed
      attendeeFields
      currency
      slug
      quickPrint
      venueId
      audienceCapacity
      builder {
        id
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        categoriesAndZones
        mobileApp
        workshops
        floorPlan
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        color
        name
        zones
      }
    }
    getAccreditationCount(eventId: $eventId)
  }
`

export const GET_EVENT_DETAILS_WITH_ORDER_ITEMS = gql`
  query getEventAccreditations($eventId: ID!) {
    getEvent(id: $eventId) {
      id
      managed
      attendeeFields
      currency
      slug
      quickPrint
      venueId
      audienceCapacity
      builder {
        id
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
        floorPlan
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        color
        name
        zones
      }
    }
    getAccreditationCount(eventId: $eventId)
    getOrderItems(eventId: $eventId) {
      items {
        id
        initialQuantity
      }
      totalCount
      hasParterTickets
    }
  }
`

export const GET_EVENT_BUILDER = gql`
  query getEventBuilder($id: ID!) {
    getEvent(id: $id) {
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
      }
      attendeeFields
      title
      numberOfZones
      builder {
        items
        backgroundImage
        orientation
        format
      }
    }
  }
`

export const GET_EVENTS_SUPERADMIN = gql`
  query GetEventsSuperadmin {
    getEvents {
      id
      title
      accreditationCount
      deletedAt
      users {
        id
        email
      }
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEMS = gql`
  query GetOrganizationOrderItems($organizationSlug: String!) {
    getOrganizationOrderItems(organizationSlug: $organizationSlug) {
      id
      name
      type
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      initialQuantity
      from
      to
      organizationId
      prepaidCouponId
      prepaidCouponInfo {
        description
      }
    }
  }
`

export const SOFT_DELETE_EVENT = gql`
  mutation SoftDeleteEvent($eventId: ID!) {
    deleteEvent(eventId: $eventId)
  }
`

export const GET_EVENT_BY_SLUG = gql`
  query GetEventBySlug($slug: String!, $ref: String) {
    getEventBySlug(slug: $slug, ref: $ref) {
      id
      attendeeFields
      numberOfZones
      title
      soldOut
      to
      performanceType
      from
      slug
      cover
      fixedFeePerTicket
      description
      managed
      applicationsOpen
      audienceCapacity
      venueId
      eventTemplateId
      flags
      numOfRemainingTickets
      canceled
      cancellationNotification
      eventTemplate {
        title
        description
        durationInMins
        break
        cover
      }
      interests {
        id
        name
      }
      translation {
        translationsJSON
      }
      eventUtils {
        id
        inviteFormStyles
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      workshops {
        id
        name
        to
        from
        lecturers {
          id
          fields
        }
        attendanceLimit
        attending
        unlimitedAttendance
        description
      }
      extraModules {
        workshops
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
        floorPlan
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      eventCategory {
        id
        name
      }
      organization {
        fixedFeePerTicket
        id
        publicName
        logo
        preferredLanguage
        description
        facebookLink
        webLink
        email
        type
      }
    }
  }
`
export const GET_APPLICATION_HEADER_DATA = gql`
  query GetApplicationHeaderData($slug: String!) {
    getApplicationHeaderData(slug: $slug) {
      id
      eventUtils {
        id
        inviteFormStyles
      }
    }
  }
`
export const GET_WORKSHOP_DETAILS_BY_EVENT_SLUG = gql`
  query GetWorkshopDetailsByEventSlug($slug: String!) {
    getWorkshopDetailsByEventSlug(slug: $slug) {
      id
      attendeeFields
      numberOfZones
      title
      soldOut
      to
      performanceType
      from
      slug
      cover
      fixedFeePerTicket
      description
      managed
      applicationsOpen
      audienceCapacity
      venueId
      eventTemplateId
      flags
      canceled
      cancellationNotification
      interests {
        id
        name
      }
      workshops {
        id
        name
        to
        from
        lecturers {
          id
          fields
        }
        attendanceLimit
        attending
        unlimitedAttendance
        description
      }
      eventCategory {
        id
        name
      }
    }
  }
`
export const GET_EVENT_DETAILS_FOR_REGISTER_CONTAINER = gql`
  query getEventDetailsForRegisterContainer($slug: String!) {
    getEventDetailsForRegisterContainer(slug: $slug) {
      id
      attendeeFields
      numberOfZones
      title
      soldOut
      to
      performanceType
      from
      slug
      cover
      fixedFeePerTicket
      description
      managed
      applicationsOpen
      audienceCapacity
      venueId
      eventTemplateId
      flags
      numOfRemainingTickets
      canceled
      cancellationNotification
      eventPasswords {
        expiresAt
      }
      eventTemplate {
        title
        description
        durationInMins
        break
        cover
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        workshops
        mobileApp
        ticketing
        floorPlan
      }
      translation {
        translationsJSON
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      organization {
        fixedFeePerTicket
        id
        publicName
        logo
        preferredLanguage
        description
        facebookLink
        webLink
        email
        type
      }
    }
  }
`

export const ACCREDITATION_COUNT = gql`
  query AccreditationCount($eventId: ID!) {
    getEvent(id: $eventId) {
      accreditationCount
    }
  }
`
export const ATTENDEE_FIELDS = gql`
  query AttendeeFields($eventId: ID!) {
    getEvent(id: $eventId) {
      attendeeFields
    }
  }
`

export const SAVE_ATTENDEE_FIELDS = gql`
  mutation SaveAttendeeFields($eventId: ID!, $attendeeFields: JSON!) {
    saveAttendeeFields(attendeeFields: $attendeeFields, eventId: $eventId)
  }
`

export const TOGGLE_EVENT_APPLICATIONS = gql`
  mutation toggleEventApplications($eventId: ID!, $applicationsOpen: Boolean!) {
    toggleEventApplications(eventId: $eventId, applicationsOpen: $applicationsOpen)
  }
`

export const GET_EVENT_CONFERENCE_DATA = gql`
  query getEventConferenceData($eventId: ID!) {
    getEventConferenceData(eventId: $eventId) {
      id
      welcomeTitle
      welcomeSubtitle
      welcomeBackground
      interests
      aboutUs
      partners
      primaryColor
      secondaryColor
      googlePlacesKey
    }
  }
`

export const UPDATE_EVENT_CONFERENCE_DATA = gql`
  mutation updateEventConferenceData($eventId: ID!, $input: UpdateEventConferenceDataInput!) {
    updateOrCreateEventConferenceData(eventId: $eventId, input: $input) {
      id
    }
  }
`
export const GET_TICKET_SELLERS_EVENTS = gql`
  query getTicketSellersEvents {
    getTicketSellersEvents {
      id
      title
      to
      from
      slug
      applicationsOpen
      cover
      description
      audienceCapacity
      numOfRemainingTickets
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        sectionSeats
        initialQuantity
        from
        to
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      extraModules {
        ticketing
        floorPlan
      }
      organization {
        id
        type
      }
    }
  }
`

export const GET_TICKET_SELLERS_EVENT = gql`
  query getTicketSellersEvent($eventId: ID!) {
    getTicketSellersEvent(eventId: $eventId) {
      id
      title
      to
      from
      venueId
      slug
      fixedFeePerTicket
      cover
      description
      audienceCapacity
      numOfRemainingTickets
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        initialQuantity
        from
        to
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      organization {
        id
        type
        fixedFeePerTicket
      }
      eventTemplate {
        id
      }
    }
    getTicketSellerOrganization {
      fees {
        useEventFeePerTicket
      }
    }
  }
`

export const GET_FLOOR_PLAN_AVAILABILITY_OVERVIEW_DATA = gql`
  query GetFloorPlanAvailabilityOverviewData($eventId: ID!) {
    getFloorPlanAvailabilityOverviewData(eventId: $eventId) {
      venue {
        id
        name
        predefinedSections
        seats
        imageUrl
      }
      soldOrderItems {
        id
        name
        soldSeats
        color
        ticketsSold
        price
      }
      availableSeats
      disabledSeats
      audienceCapacity
    }
  }
`

export const SET_MAX_TICKETS_NUMBER = gql`
  mutation SetMaxTicketsNumber($eventId: ID!, $maxTickets: Int) {
    setMaxTicketsNumber(eventId: $eventId, maxTickets: $maxTickets)
  }
`

export const CREATE_ANNUAL_TICKETS_FOR_EVENT = gql`
  mutation CreateAnnualTicketsForEvent($eventId: ID!) {
    createAnnualTicketsForEvent(eventId: $eventId)
  }
`

export const SET_EVENT_PASSWORDS_FLAG = gql`
  mutation SetEventPasswordsFlag($eventId: ID!, $eventPasswordsFlag: Boolean!) {
    setEventPasswordsFlag(eventId: $eventId, eventPasswordsFlag: $eventPasswordsFlag)
  }
`

export const GET_EVENT_EXTRA_MODULES = gql`
  query GetEventExtraModules($id: ID!) {
    getEvent(id: $id) {
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
        floorPlan
        workshops
      }
    }
    eventHasPendingOrAllowedAttendees(eventId: $id)
  }
`

export const UPDATE_EVENT_EXTRA_MODULES = gql`
  mutation UpdateEventExtraModules($eventId: ID!, $extraModulesInput: ExtraModulesInput!) {
    updateEventExtraModules(eventId: $eventId, extraModulesInput: $extraModulesInput)
  }
`

export const UPDATE_EVENT_COVER = gql`
  mutation UpdateEventCover($eventId: ID!, $cover: String) {
    updateEventCover(eventId: $eventId, cover: $cover)
  }
`

export const UPDATE_EVENT_SCHEDULED_PUBLISH_DATE = gql`
  mutation UpdateEventCover($eventId: ID!, $date: String) {
    updateEventScheduledPublishDate(eventId: $eventId, date: $date) {
      scheduledPublishDate
    }
  }
`
